import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import UnStyledImage from "./image";

const GalleryWrapper = styled.ul`
  display: grid;
  grid-template-columns: ${({ $columns }) => `repeat(${$columns}, 1fr)`};
  grid-template-rows: ${({ $columns }) => `repeat(${$columns}, auto)`};
  gap: 1rem;
  width: 100%;
  list-style-type: none;
  padding-left: 0;
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const Image = styled(UnStyledImage)`
  height: ${({ $fixedHeight }) => ($fixedHeight ? "300px" : "auto")};
  transition: transform 0.4s ease-in-out;
  .photo-item {
    display: flex;
    width: 100%;
    cursor: pointer;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    height: ${({ $fixedHeight }) => ($fixedHeight ? "200px" : "auto")};
  }
  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      transform: scale(1.02);
    }
  }
`;
const List = styled.li`
  &:before {
    display: none !important;
  }
`;

const GalleryContainer = ({
  fixedHeight,
  imageCrop,
  columns,
  photos,
  className,
}) => {
  const [activeIndex, setActiveIndex] = useState(-1);

  function addActiveClass(index) {
    index === activeIndex ? setActiveIndex(-1) : setActiveIndex(index);
  }
  return (
    <>
      <GalleryWrapper $columns={columns} className={className}>
        {photos.map((photo, index) => (
          <List onClick={() => addActiveClass(index)} key={index}>
            <Image
              objectFit={imageCrop ? "cover" : "contain"}
              $fixedHeight={fixedHeight}
              src={photo.imageUrl}
              image={photo.image}
              key={index}
              data-sal="slide-up"
              data-sal-duration="200"
              data-sal-delay="300"
              data-sal-easing="ease"
            />
            {activeIndex === index && (
              <UnStyledImage
                src={photo.imageUrl}
                image={photo.image}
                key={index}
                className="fullscreen"
                onClick={() => addActiveClass(-1)}
                objectFit={"scale-down"}
              />
            )}
          </List>
        ))}
      </GalleryWrapper>
    </>
  );
};

export default GalleryContainer;

GalleryContainer.propTypes = {
  photos: PropTypes.array,
  fixedHeight: PropTypes.bool,
  columns: PropTypes.number,
  className: PropTypes.string,
  imageCrop: PropTypes.bool,
};

GalleryContainer.defaultProps = {
  photos: [],
};
